module.exports = __webpack_public_path__ + "665472fa65b151b72a71703d830493c1.pdf";